/*
 * @Author: along longwang6@163.com
 * @Date: 2026-06-15 10:01:21
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2026-06-16 21:14:33
 * @FilePath: /ehr-web/src/components/NavBar/components/TabFeatureSwitch/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import cs from 'classnames';
import { IconInteraction } from '@arco-design/web-react/icon';
import { Tooltip } from '@arco-design/web-react';
import styles from './index.module.less';

type Props = {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
};

const TabFeatureSwitch = ({ enabled, onChange }: Props) => {
  return (
    <div className={styles.tabFeatureSwitch}>
      <Tooltip content={enabled ? '关闭标签栏' : '开启标签栏'}>
        <IconInteraction
          style={{ fontSize: 20, color: enabled ? '#165dff' : '#4e5969' }}
          onClick={() => onChange(!enabled)}
        />
      </Tooltip>
      {/* <span className={styles.label}>标签页</span>
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        aria-label={enabled ? '关闭标签页' : '开启标签页'}
        className={cs(styles.switchBtn, {
          [styles.switchBtnChecked]: enabled,
        })}
        onClick={() => onChange(!enabled)}
      >
        <span className={styles.switchHandle} />
      </button> */}
    </div>
  );
};

export default TabFeatureSwitch;
